import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'hooks/api/api';
import {
  AutomationsEmployeesService,
  EmployeeWorkspace,
} from 'src/api/generated';

interface EmployeeWorkspacesResponse extends ApiResponse {
  workspaces: EmployeeWorkspace[];
}

export const useEmployeeWorkspaces = (
  employeeId: string,
  version: string | number,
  enabled: boolean = true
): EmployeeWorkspacesResponse => {
  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery({
    queryKey: ['automations/employees/workspaces', employeeId, version],
    queryFn: async (): Promise<EmployeeWorkspace[]> =>
      AutomationsEmployeesService.listWorkspaces(employeeId, version),
    enabled: enabled && Boolean(employeeId && version),
  });

  return {
    loading,
    error: (error as Error) ?? null,
    workspaces: data ?? [],
    refetch,
  };
};
